import React from 'react';
import { Navigate, Outlet, Route } from 'react-router';

import BrowseTitlesPage from 'app/components/browse/titles/BrowseTitlesPage';
import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { BROWSE_SEARCH_PAGE_PATH, SUB_PAGE_SLUG } from 'app/constants/BrowseConstants';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import BrowseCategoryPageRoute from './BrowseCategoryPageRoute';
import BrowseHomePageRoute from './BrowseHomePageRoute';
import BrowseSearchPageRoute from './BrowseSearchPageRoute';
import BrowseTitlesNewPageRoute from './BrowseTitlesNewPageRoute';
import BrowseTitlesOnOrderPageRoute from './BrowseTitlesOnOrderPageRoute';

// Converted from react-router 5. Notes on the non-obvious parts:
//
//  - <Switch> picked the FIRST matching child; v6 <Routes> picks the BEST (most specific) match
//    regardless of order. So `/v2/browse/*` no longer shadows `/v2/browse/titles`, and the ordering
//    here is for readability only.
//  - `exact` is the v6 default. A child matching its parent's path exactly becomes `index`;
//    a route that relied on prefix matching gets an explicit `/*`.
//  - BrowseTitlesPage was a plain wrapper rendered unconditionally inside the titles Route, so at
//    /v2/browse/titles it mounted and then the sibling Redirect fired. As a layout route with an
//    index redirect, that sequence is preserved.
export default (
  <Route
    path="/v2"
    element={
      <MainLayout>
        <Outlet />
      </MainLayout>
    }
  >
    <Route index element={<Navigate replace to="/v2/browse" />} />
    <Route path="/v2/browse" element={<BrowseHomePageRoute />} />

    <Route path={`${BROWSE_SEARCH_PAGE_PATH}/*`} element={<BrowseSearchPageRoute />} />

    <Route
      path="/v2/browse/titles"
      element={
        <BrowseTitlesPage>
          <Outlet />
        </BrowseTitlesPage>
      }
    >
      <Route index element={<Navigate replace to={`/v2/browse/titles/${SUB_PAGE_SLUG.NEW}`} />} />
      <Route path={`/v2/browse/titles/${SUB_PAGE_SLUG.NEW}`} element={<BrowseTitlesNewPageRoute />} />
      <Route path={`/v2/browse/titles/${SUB_PAGE_SLUG.ON_ORDER}`} element={<BrowseTitlesOnOrderPageRoute />} />
    </Route>

    <Route path="/v2/browse/*" element={<BrowseCategoryPageRoute />} />

    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
